// Related websites select in site footer
try {
  $('.js-external-site-select').on('change', function () {
    var t = $(this)
    var externalURL = t.prop('value')

    if (externalURL !== '') {
      window.location = externalURL
      var defaultOption = t.find('option').eq(0)

      // Restore default option once page has opened in new tab:
      if (defaultOption.length) defaultOption.prop('selected','selected')
    }
  })
} catch (error) {
  console.error(error)
}

// Expands links in footer for mobile
try {
  var footerLinks = $('.js-hidden-mob-footer-links')
  if (footerLinks.length) {
    $('.js-toggle-mob-footer-links').on('click', function (e) {
      e.preventDefault()
      var t = $(this)
      var btnText = t.find('.js-footer-btn-text')

      if (footerLinks.hasClass('js-active')) {
        footerLinks.add(t).removeClass('js-active')
        btnText.text("Show site links")
      } else {
        footerLinks.add(t).addClass('js-active')
        btnText.text("Hide site links")
      }
    })
  }
} catch (error) {
  console.error(error)
}
